__turbopack_context__.v({
  "headLine": "sgiCalculator-module-scss-module__mvocgq__headLine",
  "sgiCalculatorContainer": "sgiCalculator-module-scss-module__mvocgq__sgiCalculatorContainer",
});
